module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M0 14.131c0 8.737 10.194 15.74 13.265 17.649.472.295 1.256.293 1.728-.006 3.068-1.938 13.269-9.027 13.269-17.643C28.262 6.365 21.899 0 14.131 0S0 6.365 0 14.131zm14.131 6.056c-3.345 0-6.056-2.709-6.056-6.056s2.711-6.056 6.056-6.056 6.056 2.709 6.056 6.056-2.711 6.056-6.056 6.056z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/location-pin-2.js
// module id = 1239
// module chunks = 14